import type { ReactNode } from 'react';

export enum NotiType {
  success = 'success',
  warning = 'warning',
  error = 'error',
}
export type Noti = { id: string; type: NotiType; message: ReactNode };
